import React from 'react';
import LazyAsset from 'components/LazyAsset';

/**
 * PinterestWidgetLib handles two things for us:
 *
 * - pinning an image ("Save button") via pinOne
 *
 * - embedded pins ("Pin widget") via data-pin-do="embedPin". this exists in our
 *   content and is effectively a ThirdPartyEmbed.
 *
 * see https://developers.pinterest.com/docs/widgets/getting-started/
 *
 * also see https://github.com/pinterest/widgets/blob/master/pinit_main.js for
 * source to pinit.js file and some docs on their public `PinUtils` API.
 *
 */
function PinterestWidgetLib() {
  return <LazyAsset type="js" uri="https://assets.pinterest.com/js/pinit.js" />;
}

export default PinterestWidgetLib;
